/* PDP - gallery + variant picker + sticky ATC */
(function () {
  var DEFAULT_STRINGS = {
    addToCart: 'Add to cart',
    soldOut: 'Sold out',
    unavailable: 'Unavailable',
    sizeGuide: 'Size guide',
    selectSize: 'Select your size',
  };

  /* Config inyectada por sections/product.liquid: textos traducidos + money_format
     de la tienda. Sin ella se cae a valores neutros en vez de a texto hardcodeado. */
  function readConfig(root) {
    var el = root.querySelector('[data-pdp-config]');
    var parsed = {};
    if (el) {
      try { parsed = JSON.parse(el.textContent) || {}; } catch (e) { parsed = {}; }
    }
    var strings = parsed.strings || {};
    return {
      moneyFormat: parsed.moneyFormat || '{{amount}}',
      strings: {
        addToCart: strings.addToCart || DEFAULT_STRINGS.addToCart,
        soldOut: strings.soldOut || DEFAULT_STRINGS.soldOut,
        unavailable: strings.unavailable || DEFAULT_STRINGS.unavailable,
        sizeGuide: strings.sizeGuide || DEFAULT_STRINGS.sizeGuide,
        selectSize: strings.selectSize || DEFAULT_STRINGS.selectSize,
      },
    };
  }

  /* Equivalente JS del filtro `money` de Liquid: respeta el money_format de la
     tienda para que el precio no "salte" al cambiar de variante. */
  function formatMoney(cents, format) {
    var value = typeof cents === 'string' ? parseFloat(cents.replace(/[^0-9.-]/g, '')) : cents;
    if (typeof value !== 'number' || isNaN(value)) return '';

    function group(number, precision, thousands, decimal) {
      var fixed = (number / 100.0).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var fraction = parts[1];
      return fraction ? whole + decimal + fraction : whole;
    }

    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = (format || '{{amount}}').match(placeholder);
    var token = match ? match[1] : 'amount';
    var formatted;

    switch (token) {
      case 'amount_no_decimals':
        formatted = group(value, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        formatted = group(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        formatted = group(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        formatted = group(value, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        formatted = group(value, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        formatted = group(value, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        formatted = group(value, 2, ' ', '.');
        break;
      default:
        formatted = group(value, 2, ',', '.');
    }

    return (format || '{{amount}}').replace(placeholder, formatted);
  }

  /* Registro de limpieza por sección: todo listener global o observer que cree
     un root se apunta aquí para poder soltarlo en shopify:section:unload. */
  var teardowns = new WeakMap();

  function onTeardown(root, fn) {
    var list = teardowns.get(root);
    if (!list) { list = []; teardowns.set(root, list); }
    list.push(fn);
  }

  function bindWindow(root, target, type, handler, options) {
    target.addEventListener(type, handler, options);
    onTeardown(root, function () { target.removeEventListener(type, handler, options); });
  }

  function destroyRoot(root) {
    var list = teardowns.get(root);
    if (list) {
      list.forEach(function (fn) { try { fn(); } catch (e) {} });
      teardowns.delete(root);
    }
    delete root.dataset.pdpInitialized;
  }

  function initGallery(root) {
    var track = root.querySelector('[data-gallery-track]');
    if (!track) return;
    var dots = root.querySelectorAll('[data-gallery-dots] [data-dot]');
    var counter = root.querySelector('[data-gallery-counter]');
    var counterCurrent = root.querySelector('[data-gallery-current]');
    var thumbs = root.querySelectorAll('[data-gallery-thumbs] [data-thumb]');
    var prev = root.querySelector('[data-gallery-prev]');
    var next = root.querySelector('[data-gallery-next]');
    var slides = track.querySelectorAll('[data-slide]');
    var activeIdx = 0;

    function current() { return Math.round(track.scrollLeft / track.clientWidth); }
    function go(idx) { track.scrollTo({ left: idx * track.clientWidth, behavior: 'smooth' }); }
    function pauseAll() {
      slides.forEach(function (slide) {
        var type = slide.dataset.mediaType;
        if (type === 'video') { var v = slide.querySelector('video'); if (v) v.pause(); }
        if (type === 'external_video') {
          var i = slide.querySelector('iframe');
          if (i) { try { i.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*'); } catch (e) {} }
        }
      });
    }
    var desktopMQ = window.matchMedia('(min-width: 990px)');
    function isDesktop() { return desktopMQ.matches; }

    function setActive(idx) {
      if (counterCurrent) counterCurrent.textContent = String(idx + 1);
      if (counter) counter.setAttribute('aria-label', 'Imagen ' + (idx + 1) + ' de ' + slides.length);
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === idx);
        d.classList.toggle('is-mobile-visible', i === idx || i === (idx === dots.length - 1 ? idx - 1 : idx + 1));
      });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
    }

    function goTo(idx) {
      if (isDesktop() && slides[idx]) {
        var headerOffset = (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80) + 16;
        var rect = slides[idx].getBoundingClientRect();
        var top = window.pageYOffset + rect.top - headerOffset;
        window.scrollTo({ top: top, behavior: 'smooth' });
      } else {
        go(idx);
      }
    }

    track.addEventListener('scroll', function () {
      if (isDesktop()) return;
      var idx = current();
      if (idx !== activeIdx) { pauseAll(); activeIdx = idx; }
      setActive(idx);
    }, { passive: true });

    dots.forEach(function (d, i) { d.addEventListener('click', function () { if (!isDesktop()) pauseAll(); goTo(i); }); });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function (e) { e.preventDefault(); if (!isDesktop()) pauseAll(); goTo(i); }); });
    if (prev) prev.addEventListener('click', function () { if (!isDesktop()) pauseAll(); goTo(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { if (!isDesktop()) pauseAll(); goTo(current() + 1); });

    /* Desktop: update active thumb based on which slide is most visible */
    if ('IntersectionObserver' in window && slides.length > 0) {
      var ratios = new Array(slides.length).fill(0);
      var io = new IntersectionObserver(function (entries) {
        if (!isDesktop()) return;
        entries.forEach(function (entry) {
          var i = parseInt(entry.target.dataset.slide, 10);
          if (!isNaN(i)) ratios[i] = entry.intersectionRatio;
        });
        var best = 0, bestRatio = 0;
        ratios.forEach(function (r, i) { if (r > bestRatio) { bestRatio = r; best = i; } });
        if (bestRatio > 0 && best !== activeIdx) {
          activeIdx = best;
          setActive(best);
        }
      }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
      slides.forEach(function (s) { io.observe(s); });
      onTeardown(root, function () { io.disconnect(); });
    }

    /* Mouse drag-to-swipe (mobile/tablet carousel only) */
    var isDown = false, startX = 0, startScroll = 0, dragged = false;
    track.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      if (isDesktop()) return;
      isDown = true; dragged = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.style.cursor = 'grabbing';
    });
    bindWindow(root, window, 'mousemove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) { dragged = true; e.preventDefault(); }
      track.scrollLeft = startScroll - dx;
    });
    bindWindow(root, window, 'mouseup', function () {
      if (!isDown) return;
      isDown = false;
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
      track.style.cursor = '';
      if (dragged) {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        var clamped = Math.max(0, Math.min(slides.length - 1, idx));
        track.scrollTo({ left: track.clientWidth * clamped, behavior: 'smooth' });
      }
    });
  }

  function initVariantPicker(form, root, config) {
    var variantsEl = root.querySelector('[data-product-json]');
    if (!variantsEl) return;
    var variants;
    try { variants = JSON.parse(variantsEl.textContent); } catch (e) { return; }
    if (!Array.isArray(variants)) return;

    var variantInput = form.querySelector('[data-variant-id]');
    var priceWrap = root.querySelector('[data-price]');
    var atc = form.querySelector('[data-add-to-cart]');
    var atcText = form.querySelector('[data-atc-text]');
    var soldOutSignup = root.querySelector('[data-sold-out-signup]');
    var sizeInputs = form.querySelectorAll('.pdp__option--size input[data-option-input]');

    var externalOnUpdate = null;
    form._onVariantUpdate = function (fn) { externalOnUpdate = fn; };

    function selectedOptions() {
      var inputs = form.querySelectorAll('input[name^="options["]:checked');
      var opts = [];
      inputs.forEach(function (input) {
        var position = parseInt(input.getAttribute('data-option-input'), 10);
        if (position > 0) opts[position - 1] = input.value;
      });
      return opts;
    }
    function findVariant(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); }) || null;
    }
    function normalizeLabel(text) {
      return String(text || '').replace(/cinturon/gi, function (word) {
        return word === 'CINTURON' ? 'CINTURÓN' : word[0] === 'C' ? 'Cinturón' : 'cinturón';
      });
    }
    function updateLabels() {
      var groups = form.querySelectorAll('[name^="options["]');
      var seen = {};
      groups.forEach(function (input) {
        var name = input.name;
        if (seen[name]) return;
        seen[name] = true;
        form.querySelectorAll('[name="' + name + '"]').forEach(function (i) {
          var label = i.closest('label');
          if (label) label.classList.toggle('is-active', i.checked);
        });
      });
    }
    function updateOptionValues(opts) {
      form.querySelectorAll('[data-option-value]').forEach(function (el) {
        var pos = parseInt(el.getAttribute('data-option-value'), 10);
        if (!pos || !opts[pos - 1]) return;
        el.textContent = normalizeLabel(opts[pos - 1]);
      });
    }
    function optionNameFromInput(input) {
      var match = input.name.match(/^options\[(.*)\]$/);
      return match ? match[1] : '';
    }
    function isSizeOptionName(name) {
      return /^(talla|size)$/i.test(normalizeLabel(name).trim());
    }
    function optionValueHasStock(input, opts) {
      var pos = parseInt(input.getAttribute('data-option-input'), 10);
      var optionName = optionNameFromInput(input);
      var isSize = isSizeOptionName(optionName);
      if (!pos) return false;

      return variants.some(function (variant) {
        if (!variant.available || variant.options[pos - 1] !== input.value) return false;

        return variant.options.every(function (value, index) {
          if (index === pos - 1) return true;
          var selected = opts[index];
          if (!selected) return true;

          var relatedInput = form.querySelector('input[data-option-input="' + (index + 1) + '"]');
          var relatedName = relatedInput ? optionNameFromInput(relatedInput) : '';
          var relatedIsSize = isSizeOptionName(relatedName);

          if (!isSize && relatedIsSize) return true;
          return value === selected;
        });
      });
    }
    function updateOptionAvailability(opts) {
      form.querySelectorAll('input[name^="options["]').forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-input'), 10);
        var label = input.closest('label');
        if (!pos || !label) return;
        label.classList.toggle('is-unavailable', !optionValueHasStock(input, opts));
      });
    }
    function money(cents) { return formatMoney(cents, config.moneyFormat); }
    function renderPrice(variant) {
      if (!priceWrap || !variant) return;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWrap.innerHTML = '<span class="pdp__price-sale">' + money(variant.price) + '</span><span class="pdp__price-compare">' + money(variant.compare_at_price) + '</span>';
      } else {
        priceWrap.innerHTML = '<span class="pdp__price-regular">' + money(variant.price) + '</span>';
      }
    }
    function updateMissingSize(opts) {
      var matching = variants.filter(function (variant) {
        return variant.options.every(function (value, index) { return !opts[index] || value === opts[index]; });
      });
      var preview = matching.find(function (variant) { return variant.available; }) || matching[0];
      variantInput.value = '';
      renderPrice(preview);
      atc.disabled = true;
      atc.classList.toggle('is-sold-out', !!preview && !preview.available);
      atcText.textContent = preview && !preview.available ? config.strings.soldOut : config.strings.selectSize;
      if (soldOutSignup) {
        soldOutSignup.hidden = !preview || preview.available;
        soldOutSignup.classList.toggle('is-hidden', !preview || preview.available);
      }
    }
    function updateVariantDisplay(variant) {
      if (!variant) {
        variantInput.value = '';
        atc.disabled = true;
        atcText.textContent = config.strings.unavailable;
        if (soldOutSignup) {
          soldOutSignup.hidden = false;
          soldOutSignup.classList.remove('is-hidden');
        }
        return;
      }
      variantInput.value = variant.id;
      form.querySelectorAll('[data-bigblue-fast-tag]').forEach(function (el) {
        el.setAttribute('data-variant', variant.id);
      });
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      } catch (e) {}
      renderPrice(variant);
      if (root.dataset.comingSoon === 'true') {
        atc.disabled = true;
        atcText.textContent = 'COMING SOON';
        return;
      }
      if (variant.available) {
        atc.disabled = false;
        atc.classList.remove('is-sold-out');
        atcText.textContent = config.strings.addToCart;
        if (soldOutSignup) {
          soldOutSignup.hidden = true;
          soldOutSignup.classList.add('is-hidden');
        }
      } else {
        atc.disabled = true;
        atc.classList.add('is-sold-out');
        atcText.textContent = config.strings.soldOut;
        if (soldOutSignup) {
          soldOutSignup.hidden = false;
          soldOutSignup.classList.remove('is-hidden');
        }
      }
    }
    function update() {
      var opts = selectedOptions();
      var variant = findVariant(opts);
      updateLabels();
      updateOptionValues(opts);
      updateOptionAvailability(opts);
      if (sizeInputs.length && !form.querySelector('.pdp__option--size input:checked')) {
        updateMissingSize(opts);
        if (externalOnUpdate) externalOnUpdate(null);
      } else {
        updateVariantDisplay(variant);
        if (externalOnUpdate) externalOnUpdate(variant);
      }
    }
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[name^="options["]')) update();
    });
    form.addEventListener('submit', function (e) {
      if (!sizeInputs.length || form.querySelector('.pdp__option--size input:checked')) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      form.querySelector('.pdp__option--size').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
    updateLabels();
    updateOptionAvailability(selectedOptions());
    if (sizeInputs.length && !form.querySelector('.pdp__option--size input:checked')) {
      updateMissingSize(selectedOptions());
    }

    return function getCurrentVariant() { return findVariant(selectedOptions()); };
  }

  function initMobileBuySticky(root) {
    // Patrón Pompeii: en mobile, .pdp__buy se vuelve position:fixed bottom 0
    // (siempre visible). Un spacer al FINAL del PDP reserva alto para que el
    // último contenido no quede tapado. visualViewport ajusta cuando aparece
    // el teclado iOS. Safe-area respetada vía CSS.
    var buy = root.querySelector('[data-buy-section]');
    if (!buy) return;

    var MOBILE_MAX = 749;

    // Spacer al final de la section .pdp (no antes de .pdp__buy) para que
    // no aparezca un hueco vacío en mitad del contenido.
    var spacer = document.createElement('div');
    spacer.className = 'pdp__buy-spacer';
    root.appendChild(spacer);

    var rafId = null;

    function isMobile() { return window.innerWidth <= MOBILE_MAX; }

    function updateViewportOffset() {
      var bottomOffset = 0;
      if (window.visualViewport) {
        bottomOffset = Math.max(
          0,
          Math.round(window.innerHeight - window.visualViewport.height - window.visualViewport.offsetTop)
        );
      }
      buy.style.setProperty('--pdp-mobile-viewport-offset', bottomOffset + 'px');
    }

    function syncSpacer() {
      if (!isMobile()) {
        spacer.style.height = '0px';
        return;
      }
      var h = buy.getBoundingClientRect().height;
      spacer.style.height = Math.ceil(h) + 'px';
    }

    function tick() {
      rafId = null;
      if (!isMobile()) {
        buy.style.removeProperty('--pdp-mobile-viewport-offset');
        buy.classList.remove('is-sticky-active');
        spacer.style.height = '0px';
        return;
      }
      updateViewportOffset();
      buy.classList.add('is-sticky-active');
      syncSpacer();
    }

    function schedule() {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(tick);
    }

    schedule();

    bindWindow(root, window, 'resize', schedule, { passive: true });
    bindWindow(root, window, 'orientationchange', schedule);
    bindWindow(root, window, 'load', schedule);

    if (window.visualViewport) {
      bindWindow(root, window.visualViewport, 'resize', schedule);
      bindWindow(root, window.visualViewport, 'scroll', schedule);
    }

    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { schedule(); });
      ro.observe(buy);
      onTeardown(root, function () { ro.disconnect(); });
    }

    onTeardown(root, function () {
      if (rafId !== null) cancelAnimationFrame(rafId);
      if (spacer.parentNode) spacer.parentNode.removeChild(spacer);
    });
  }

  function initWishlistPlacement(root) {
    var buy = root.querySelector('[data-buy-section]');
    var atc = buy && buy.querySelector('[data-add-to-cart]');
    var media = root.querySelector('[data-pdp-wishlist-media]');
    if (!buy || !atc || !media) return;

    function place() {
      var wishlist = buy.querySelector(':scope > wishlist-button-product') || media.querySelector('wishlist-button-product');
      if (!wishlist) return;

      if (window.innerWidth <= 749) {
        if (wishlist.parentElement !== media) media.appendChild(wishlist);
      } else if (wishlist.parentElement !== buy || wishlist.previousElementSibling !== atc) {
        atc.insertAdjacentElement('afterend', wishlist);
      }
    }

    var observer = new MutationObserver(place);
    observer.observe(buy, { childList: true });
    observer.observe(media, { childList: true });
    bindWindow(root, window, 'resize', place, { passive: true });
    onTeardown(root, function () { observer.disconnect(); });
    place();
  }

  function initAccordionLinks(root) {
    root.querySelectorAll('[data-accordion-trigger]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(btn.dataset.accordionTrigger);
        if (target && target.tagName === 'DETAILS') {
          target.open = true;
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  function initKiwiSizeChart(root, config) {
    var chart = root.querySelector('#KiwiSizingChart, #kiwi-size-chart, .pdp__kiwi-size-chart');
    var triggers = root.querySelectorAll('[data-kiwi-size-trigger]');
    if (!triggers.length) return;
    var pendingTrigger = null;
    var pendingTimer = null;

    function findOpener() {
      var scopes = [chart, root, document].filter(Boolean);
      for (var s = 0; s < scopes.length; s++) {
        var directMatch = scopes[s].querySelector('.ks-chart-modal-link, .sizing-chart-modal-link, [data-kiwi-modal-link], [data-sizing-chart-open]');
        if (directMatch) return directMatch;
      }
      return null;
    }
    function prepareOpener(opener) {
      if (!opener) return;
      opener.classList.add('pdp__kiwi-opener-source');
      opener.setAttribute('data-kiwi-opener-source', 'true');
    }
    function mountOpener() {
      var opener = findOpener();
      if (!opener) return;
      prepareOpener(opener);
      if (chart) chart.classList.add('pdp__kiwi-size-chart--ready');
      if (pendingTrigger) {
        pendingTrigger.removeAttribute('aria-busy');
        pendingTrigger = null;
        clearTimeout(pendingTimer);
        triggerOpener(opener);
      }
    }
    function triggerOpener(el) {
      // On touch devices (iPad) the Kiwi opener often listens on pointer/touch
      // events, so a bare synthetic click() doesn't open the modal. Fire the
      // full pointer/mouse sequence there; desktop keeps the plain click().
      var coarse = false;
      try { coarse = window.matchMedia('(pointer: coarse)').matches; } catch (e) {}
      if (coarse) {
        var o = { bubbles: true, cancelable: true, view: window };
        try { el.dispatchEvent(new PointerEvent('pointerdown', o)); } catch (e) {}
        try { el.dispatchEvent(new MouseEvent('mousedown', o)); } catch (e) {}
        try { el.dispatchEvent(new PointerEvent('pointerup', o)); } catch (e) {}
        try { el.dispatchEvent(new MouseEvent('mouseup', o)); } catch (e) {}
      }
      el.click();
    }
    triggers.forEach(function (trigger) {
      if (trigger.dataset.kiwiTriggerBound) return;
      trigger.dataset.kiwiTriggerBound = 'true';
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var opener = findOpener();
        if (opener && opener !== trigger) {
          prepareOpener(opener);
          triggerOpener(opener);
          return;
        }
        // Kiwi loads asynchronously. Wait for its real opener; never rewrite
        // an app wrapper, which may still contain the scripts and chart mount.
        if (pendingTrigger) pendingTrigger.removeAttribute('aria-busy');
        pendingTrigger = trigger;
        trigger.setAttribute('aria-busy', 'true');
        clearTimeout(pendingTimer);
        pendingTimer = setTimeout(function () {
          if (pendingTrigger) pendingTrigger.removeAttribute('aria-busy');
          pendingTrigger = null;
        }, 12000);
      });
    });
    if (chart && !chart.dataset.kiwiObserverBound) {
      chart.dataset.kiwiObserverBound = 'true';
      mountOpener();
      var localize = function () { mountOpener(); };
      var observer = new MutationObserver(localize);
      observer.observe(chart, { childList: true, subtree: true });
      setTimeout(mountOpener, 500);
      setTimeout(mountOpener, 1500);
    }
  }

  function hideExtraSizeChartLinks(root) {
    var info = root.querySelector('.pdp__info');
    if (!info) return;
    function sweep() {
      var candidates = info.querySelectorAll('a, button, span, div');
      candidates.forEach(function (el) {
        if (el.classList.contains('pdp__size-guide-link')) return;
        if (el.closest && el.closest('.pdp__size-guide-link')) return;
        if (el.closest && el.closest('.pdp__kiwi-size-inline')) return;
        if (el.children && el.children.length > 1) return;
        var txt = (el.textContent || '').trim().toLowerCase();
        if (txt === 'size chart' || txt === 'sizechart' || txt === 'size guide') {
          el.style.position = 'absolute';
          el.style.left = '-9999px';
          el.style.width = '1px';
          el.style.height = '1px';
          el.style.opacity = '0';
          el.style.pointerEvents = 'none';
          el.setAttribute('aria-hidden', 'true');
        }
      });
    }
    sweep();
    setTimeout(sweep, 400);
    setTimeout(sweep, 1200);
    setTimeout(sweep, 2500);
  }

  function initRoot(root) {
    /* El editor destruye y recrea el DOM de la sección; sin este guard una
       recarga volvía a enganchar listeners y a inyectar otro .pdp__buy-spacer
       sobre los roots que no se habían recargado. */
    if (root.dataset.pdpInitialized === 'true') return;
    root.dataset.pdpInitialized = 'true';

    var config = readConfig(root);
    initGallery(root);
    var form = root.querySelector('[data-pdp-form]');
    if (form) initVariantPicker(form, root, config);
    initAccordionLinks(root);
    initKiwiSizeChart(root, config);
    initMobileBuySticky(root);
    initWishlistPlacement(root);
    hideExtraSizeChartLinks(root);
  }

  function init(scope) {
    var container = scope || document;
    if (container.matches && container.matches('.pdp')) initRoot(container);
    container.querySelectorAll('.pdp').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* Sólo se re-inicializa la sección recargada (e.target), nunca la página entera. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var container = e.target;
    if (!container || !container.querySelectorAll) return;
    if (container.matches && container.matches('.pdp')) destroyRoot(container);
    container.querySelectorAll('.pdp').forEach(destroyRoot);
  });
})();
